var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCaretred(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 32,
    viewBox: "0 0 36 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.42847 7.63708H31.3812C31.8868 7.6371 32.3868 7.73427 32.849 7.92232C33.3111 8.11037 33.7252 8.38514 34.0644 8.7289C34.4037 9.07267 34.6606 9.47781 34.8187 9.9182C34.9767 10.3586 35.0324 10.8245 34.9821 11.2858L33.8964 21.2414C33.8071 22.0602 33.3892 22.8195 32.7238 23.3717C32.0584 23.9239 31.193 24.2297 30.2955 24.2297H13.015C12.178 24.23 11.3669 23.9643 10.7196 23.4778C10.0722 22.9914 9.62882 22.3142 9.46478 21.5616L6.42847 7.63708Z",
    stroke: "#E84242",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.42845 7.63705L4.96277 2.25606C4.86474 1.89725 4.63878 1.57877 4.32078 1.35119C4.00277 1.12362 3.61095 1.00001 3.20757 1H1",
    stroke: "#E84242",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8569 30.8667H15.4759",
    stroke: "#E84242",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3328 30.8667H29.9517",
    stroke: "#E84242",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretred);
export default __webpack_public_path__ + "static/media/caretred.529104e275cd75d816ad802288c0b3f2.svg";
export { ForwardRef as ReactComponent };